import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { NLMPatientEducationDefinition } from '../../models/nlm-patient-education-definition';
import { storeByIMPSId } from '../../utils/converter';
import { getNLMPatientEducationDefinitions } from '../../apis/emr-data';

export interface State {
    byId: Dictionary<NLMPatientEducationDefinition>;
    loading: Dictionary<boolean>;
}

export const nlmPatientEducationDefinitions = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: MixType<NLMPatientEducationDefinition>,
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                return {
                    ...state,
                    byId: {
                        ...state.byId,
                        ...storeByIMPSId(data)
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getNLMPatientEducationDefinitionsAsync(
            ids: Undefinable<number>[],
            rootState: RootState
        ) {
            const notExistedIds = selectors.getOtherNLMPatientEducationDefinitionIds(rootState.nlmPatientEducationDefinitions, ids);
            if (notExistedIds.length > 0) {
                try {
                    const data = await getNLMPatientEducationDefinitions(notExistedIds);
                    this.update(data);
                } catch (e) {
                    window.console.log(e);
                }
            }
        }
    })
});
